import { z } from "zod";

export const YES_NO_NA = ["yes", "no", "na"] as const;
export const COMPLY_STATUSES = ["comply", "do_not_comply"] as const;

export const rsdsDeclarationCreateSchema = z.object({
  vendorCodes: z.array(z.string().min(1)).min(1),
  responsibilities: z.array(
    z.object({ statementKey: z.string(), answer: z.enum(YES_NO_NA) })
  ),
  materialAnswers: z.array(
    z.object({
      substanceId: z.number().int(),
      answer: z.enum(YES_NO_NA),
      nonCompliantParts: z
        .array(z.object({ partNumber: z.string(), concentrationPpm: z.number().nonnegative() }))
        .optional(),
    })
  ),
  statementsOfCompliance: z.array(
    z.object({ statementKey: z.string(), answer: z.enum(COMPLY_STATUSES) })
  ),
});
export type RsdsDeclarationCreateInput = z.infer<typeof rsdsDeclarationCreateSchema>;

export const rsdsApprovalSchema = z.object({
  declarationId: z.number().int(),
  decision: z.enum(["approve", "reject"]),
  comment: z.string().optional(),
});
